<template>
<div class="chapter">
<div class="inner_page">
<p class="image-l" id="front"><a id="page_8"></a><img alt="Images" src="images/common.jpg"/></p>
<p class="bq-a"><a id="index1"><strong>“TO TASTEFUL PALATES, KEEN APPETITES, AND HEALTHFUL AND CAPACIOUS STOMACHS.”</strong></a></p><a id="index1">
</a><p class="att"><a id="index1"></a><a id="index2"><strong>—WILLIAM KITCHINER,</strong> <em><strong>Apicius Redivivus: Or, The Cook’s Oracle</strong></em> <strong>(1817)</strong></a></p><a id="index2">
</a><p class="image-b"><a id="index2"></a><a id="index3"></a><a id="page_9"></a><a id="f0009-01"><img alt="Images" src="images/f0009-01.jpg"/></a></p><a id="f0009-01">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front.vue?529f9e04